export enum UserRewardsQueryKeys {
  Primary = '/user-rewards',
  ByReward = '/user-rewards/by-reward/:rewardId',
}
